import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  chatMessages: [],
  conversationId: null,
};

const aiChatSlice = createSlice({
  name: "dictation",
  initialState: initialState,
  reducers: {
    setChatMessages: (state, action) => {
      state.chatMessages = action.payload;
    },
    updateLastAIMessage: (state, action) => {
      if (state.chatMessages.length > 0) {
        // replace the last message if it's AI
        const lastIndex = state.chatMessages.length - 1;
        if (state.chatMessages[lastIndex].role === "ai") {
          state.chatMessages[lastIndex].content = action.payload;
          state.chatMessages[lastIndex].loading = false;
        }
      }
    },
    setConversationId: (state, action) => {
      state.conversationId = action.payload;
    },
    resetDictation: () => initialState,
  },
});

export const { setChatMessages, setConversationId, updateLastAIMessage } =
  aiChatSlice.actions;

export default aiChatSlice.reducer;
